import { AxiosInstance } from 'axios';
import baseAxios, { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';
import fbaTransportPreferencesFactory from './fbaTransportPreferences';
import fbaTransportV2024Factory from './fbaTransportV2024';
import inboundFactory from './inbound';
import outboundFactory from './outbound';

interface ShipmentsApiReturn {
    outbound: ReturnType<typeof outboundFactory>
    inbound: ReturnType<typeof inboundFactory>
    fbaTransportV2024: ReturnType<typeof fbaTransportV2024Factory>
    fbaTransportPreferences: ReturnType<typeof fbaTransportPreferencesFactory>
}

export default (axios: AxiosInstance = baseAxios, migratedAxios: AxiosInstance = axiosWithoutCaseMiddleware): ShipmentsApiReturn => ({
    outbound: outboundFactory(axios),
    inbound: inboundFactory(axios),
    fbaTransportV2024: fbaTransportV2024Factory(migratedAxios),
    fbaTransportPreferences: fbaTransportPreferencesFactory(migratedAxios),
});
